// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'toggle_collapse_menu';
export const DRAWER_TYPE = 'drawer_type';
export const FIXED_DRAWER = 'fixed_drawer';
export const COLLAPSED_DRAWER = 'collapsible';
export const MINI_DRAWER = 'mini_drawer';
export const THEME_COLOR = 'theme_color';
export const DARK_THEME = 'dark_theme';
export const WINDOW_WIDTH = 'window-width';
export const SWITCH_LANGUAGE = 'switch-language';
export const CHANGE_DIRECTION = 'change-direction';

export const CHANGE_NAVIGATION_STYLE = 'change-navigation-style';
export const HORIZONTAL_NAVIGATION = 'horizontal_navigation';
export const VERTICAL_NAVIGATION = 'vertical_navigation';

export const HORIZONTAL_MENU_POSITION = 'horizontal_menu_position';
export const ABOVE_THE_HEADER = 'above_the_header';
export const INSIDE_THE_HEADER = 'inside_the_header';
export const BELOW_THE_HEADER = 'below_the_header';


//users
export const ON_REGISTER_USER_DATA = 'on_register_user_data';
export const ON_USER_UPDATE = 'on_register_user_data';
export const ON_REGISTER_START = 'fetch_start';
export const ON_REGISTER_SUCCESS = 'fetch_success';
export const ON_REGISTER_ERROR = 'fetch_error';
export const ON_USER_UPDATE_ERROR = 'on_user_update_error';
export const ON_USER_UPDATE_SUCCESS = 'on_user_update_success';
export const ON_USER_UPDATE_START = 'on_user_update_start';

export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'show_message';
export const HIDE_MESSAGE = 'hide_message';

export const FETCH_ALL_CONTACT = 'fetch_all_contact';
export const FETCH_ALL_CONTACT_SUCCESS = 'fetch_all_contact_success';
export const ADD_FAVOURITE = 'add_favourite';
export const ON_CONTACT_SELECT = 'on_contact_select';
export const ON_ADD_CONTACT = 'on_add_contact';
export const ON_CONTACT_CLOSE = 'on_contact_close';
export const ON_FILTER_OPTION_SELECT = 'on_filter_option_select';
export const ON_SAVE_CONTACT = 'on_save_contact';
export const ON_DELETE_CONTACT = 'on_delete_contact';
export const ON_DELETE_SELECTED_CONTACT = 'on_delete_selected_contact';
export const FILTER_CONTACT = 'filter_contact';
export const GET_ALL_CONTACT = 'get_all_contact';
export const GET_UNSELECTED_ALL_CONTACT = 'get_unselected_all_contact';
export const ON_ALL_CONTACT_SELECT = 'on_all_contact_select';
export const UPDATE_SEARCH_USER = 'update_search_user';
export const ON_TOGGLE_DRAWER = 'on_toggle_drawer';
export const HANDLE_REQUEST_CLOSE = 'handle_request_close';
export const HIDE_CONTACT_LOADER = 'hide_contact_loader';

//Auth const
export const SIGNUP_USER = 'signup_user';
export const SIGNUP_USER_SUCCESS = 'signup_user_success';
export const SIGNIN_GOOGLE_USER = 'signin_google_user';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'signin_google_user_success';
export const SIGNIN_FACEBOOK_USER = 'signin_facebook_user';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'signin_facebook_user_success';
export const SIGNIN_TWITTER_USER = 'signin_twitter_user';
export const SIGNIN_TWITTER_USER_SUCCESS = 'signin_twitter_user_success';
export const SIGNIN_GITHUB_USER = 'signin_github_user';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_SUCCESS';
export const SIGNIN_USER = 'signin_user';
export const SIGNIN_USER_SUCCESS = 'signin_user_success';
export const SIGNOUT_USER = 'signout_user';
export const SIGNOUT_USER_SUCCESS = 'signout_user_success';
export const INIT_URL = 'init_url';
export const USER_DATA = 'user_data';
//export const USER_DATA = 'user_data';
export const ON_USERS_LIST = 'on_users_list';
export const USER_TOKEN_SET = 'user_token_set';
export const SET_USER_BIO_AUTH_PASSED = 'set_user_bio_auth_passed';
export const SET_USER_BIO_AUTH_CHECKING = 'set_user_bio_auth_checking';


export const FETCH_ALL_CHAT_USER = 'fetch_all_chat_user';
export const FETCH_ALL_CHAT_USER_CONVERSATION = 'fetch_all_chat_user_conversation';
export const FETCH_ALL_CHAT_USER_SUCCESS = 'fetch_all_chat_user_success';
export const FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS = 'fetch_all_chat_user_conversation_success';
export const FILTER_USERS = 'filter_users';
export const ON_SELECT_USER = 'on_select_user';
export const ON_SHOW_LOADER = 'on_show_loader';
export const ON_HIDE_LOADER = 'on_hide_loader';
export const USER_INFO_STATE = 'user_info_state';
export const SUBMIT_COMMENT = 'submit_comment';
export const UPDATE_MESSAGE_VALUE = 'update_message_value';
export const UPDATE_SEARCH_CHAT_USER = 'update_search_chat_user';

//// Mail Module const


export const ADD_LABEL = 'ADD_LABEL';
export const GET_ALL_MAIL = 'get_all_mail';
export const FETCH_ALL_MAIL = 'fetch_all_mail';
export const FETCH_ALL_MAIL_SUCCESS = 'fetch_all_mail_success';
export const GET_IMPORTANT_MAIL = 'get_important_mail';
export const GET_NAV_FILTERS = 'get_nav_filters';
export const GET_NAV_LABELS = 'get_nav_labels';
export const GET_NAV_FOLDER = 'get_nav_folder';
export const GET_READ_MAIL = 'get_read_mail';
export const GET_STARRED_MAIL = 'get_starred_mail';
export const GET_UNIMPORTANT_MAIL = 'get_unimportant_mail';
export const GET_UNREAD_MAIL = 'get_unread_mail';
export const GET_UNSELECTED_ALL_MAIL = 'get_unselected_all_mail';
export const GET_UNSTARRED_MAIL = 'get_unstarred_mail';
export const ON_ALL_MAIL_SELECT = 'on_all_mail_select';
export const ON_FOLDER_MENU_ITEM_SELECT = 'on_folder_menu_item_select';
export const ON_FOLDER_SELECT = 'on_folder_select';
export const ON_IMPORTANT_SELECT = 'on_important_select';
export const ON_LABEL_MENU_ITEM_SELECT = 'on_label_menu_item_select';
export const GET_MARK_AS_START = 'get_mark_as_start';
export const ON_LABEL_SELECT = 'on_label_select';
export const ON_MAIL_CHECKED = 'on_mail_checked';
export const ON_MAIL_SELECT = 'on_mail_select';
export const ON_MAIL_SEND = 'on_mail_send';
export const ON_OPTION_MENU_ITEM_SELECT = 'on_option_menu_item_select';
export const ON_OPTION_MENU_SELECT = 'on_option_menu_select';
export const ON_START_SELECT = 'on_start_select';
export const SEARCH_MAIL = 'search_mail';
export const ON_DELETE_MAIL = 'on_delete_mail';
export const SET_CURRENT_MAIL_NULL = 'set_current_mail_null';
export const ON_COMPOSE_MAIL = 'on_compose_mail';

//// TO-DO Module const

export const ON_SORTEND = 'on_sortend';
export const FETCH_ALL_TODO = 'fetch_all_todo';
export const FETCH_ALL_TODO_SUCCESS = 'fetch_all_todo-success';
export const FETCH_ALL_TODO_CONVERSATION = 'fetch_all_todo_conversation';
export const FETCH_ALL_TODO_CONVERSATION_SUCCESS = 'fetch_all_todo_conversation_success';
export const SELECT_ALL_TODO = 'select_all_todo';
export const GET_ALL_TODO = 'get_all_todo';
export const GET_UNSELECTED_ALL_TODO = 'get_unselected_all_todo';
export const GET_STARRED_TODO = 'get_starred_todo';
export const GET_UNSTARRED_TODO = 'get_unstarred_todo';
export const GET_IMPORTANT_TODO = 'get_important_todo';
export const GET_UNIMPORTANT_TODO = 'get_unimportant_todo';
export const ON_LABEL_UPDATE = 'on_label_update';
export const ON_TODO_UPDATE = 'on_todo_update';
export const ON_DELETE_TODO = 'on_delete_todo';
export const SEARCH_TODO = 'search_todo';
export const SHOW_TODOS = 'show_todos';
export const GET_TODO_CONVERSATION = 'get_todo_conversation';
export const ON_TODO_CHECKED = 'on_todo_checked';
export const ON_TODO_ADD = 'on_todo_add';
export const ON_TODO_SELECT = 'on_todo_select';
export const SET_CURRENT_TODO_NULL = 'set_current_todo_null';
export const REMOVE_LABEL = 'remove_label';
export const UPDATE_SEARCH = 'update_search';

// Common Data values
export const ON_SAFECUSTODY_CENTERS_LIST = 'on_safecustody_center_list';

// Consignments Module
export const ON_CONSIGNMENT_TYPE_CHANGE = 'on_consignment_type_change';
export const CONSIGNMENTS_DATA = 'consignment_data';
export const CONSIGNMENT_POST_DATA = 'consignment_post_data';
export const CONSIGNMENT_POST_DATA_ERROR = 'consignment_post_data_error';
export const ON_DENOMINATION_ADD = 'on_denomination_add';
export const ON_VIEWSINGLE_CONSIGNMENT = 'on_vewsingle_consignment';
export const ON_CONSIGNMENT_UPDATE = 'on_consignment_update';
export const ON_CONSIGNMENT_UPDATE_ERROR = 'on_consignment_update_error';
export const CENTER_LIMITS_DATA = 'center_limits_data';
// Denomination List
export const ON_DENOMINATION_LIST = 'on_denomination_list';

// Intents Module
export const ON_INTENT_TYPE_CHANGE = 'on_intent_type_change';
export const INTENT_REQUEST_DATA = 'intent_requests_data';
export const INTENT_POST_RESPONSE = 'intent_post_data';
export const INTENT_POST_START = "intent_post_start";
export const INTENT_INITIAL_FORM_DATA = 'intent_initial_form_data';
export const INTENT_DENOMINATIONS_FORM_DATA = 'intent_denominations_form_data';
export const INTENT_OFFICERS_FORM_DATA = 'intent_officers_form_data';
export const DENOMINATIONS_LIST = "denominations_list";
export const OFFICERS_LIST = "officers_list";
export const ON_INTENT_SUBMIT_ERRORS = "on_intent_submit_errors";
export const ON_PUT_RESPONSE = "intent_put_response";
export const BANKS_LIST = "banks_list";
export const CENTERS_LIST = "custody_centers_list";
export const BANKS_BRANCHES_LIST = "banks_branches_list";
export const ON_PATCH_RESPONSE = "patch_response";
export const LOAD_INTENT_SINGLE_START = 'load_intent_single_start';
export const LOAD_INTENT_SINGLE_DONE = 'load_intent_single_done';
export const SINGLE_INTENT_DATA = 'single_intent_data';

export const INTENT_INIT = "intent_init";
export const EOD_SNAPSHOT = "eod_snapshot";
export const EOD_SNAPSHOT_DENOM = "eod_snapshot_demon";
export const COMMON_INIT = "common_init";
export const EOD_INIT = "eod_init";
export const LOAD_INTENTS = "load_intents";

//Custody Centres
export const ON_CUSTODY_CENTERS_LIST = 'on_custody_centres_list';
export const ON_CUSTODY_CENTER_ADD = 'on_custody_centre_add';
export const ON_CUSTODY_CENTER_UPDATE = 'on_custody_centre_update';
export const SCC_STOCKBALANCES_DATA = 'scc_stockbalances_data';
export const SCC_STOCKBALANCES_DATA_INIT = 'scc_stockbalances_data_init';
export const SCC_STOCK_HOLDING_DATA = 'scc_stock_holding_value';

//Roles
export const ON_ROLES_LIST = 'on_roles_list';
export const ON_ROLES_ADD = 'on_roles_add';
export const ON_ROLES_UPDATE = 'on_roles_update';

//Resources
export const ON_RESOURCES_LIST = 'on_resources_list';
export const ON_RESOURCES_ADD = 'on_resources_add';
export const ON_RESOURCES_UPDATE = 'on_resources_update';

//Banks
export const ON_BANK_LIST = 'on_bank_list';
export const ON_BANK_ADD = 'on_bank_add';
export const ON_BANK_UPDATE = 'on_bank_update';

//Stock Balance
export const ON_STOCK_BALANCE = 'on_stock_balance';
export const ON_STOCK_BALANCE_UNCOUNTED = 'on_stock_balance_uncounted';
export const ON_STOCK_BALANCE_INTRANSIT = 'on_stock_balance_intransit';
export const ON_STOCK_BALANCE_INTRANSIT_UNCOUNTED = 'on_stock_balance_intransit_uncounted';

//Transaction Trend
export const ON_TRANSACTION_TREND = 'on_transaction_trend';
export const ON_INCOMPLETE_TRANSACTIONS = 'on_incomplete_transactions';

//Pending Intents
export const ON_PENDING_INTENTS = 'on_pending_intents';
export const ON_REJECTED_INTENTS = 'on_rejected_intents';

//Pending Consignments
export const ON_PENDING_CONSIGNMENTS = 'on_pending_consignments';
export const ON_REJECTED_CONSIGNMENTS = 'on_rejected_consignments';

//Bank Branches
export const ON_BANK_BRANCH_LIST = 'on_bank_branch_list';
export const ON_BANK_BRANCH_ADD = 'on_bank_branch_add';
export const ON_BANK_BRANCH_UPDATE = 'on_bank_branch_update';

//password policy
export const ON_PASSWORD_POLICY_LIST = 'on_password_policy_list';
export const ON_PASSWORD_POLICY_ADD = 'on_password_policy_add';
export const ON_PASSWORD_POLICY_UPDATE = 'on_password_policy_update';

//Resource Actions
export const ON_ACTIONS_LIST = 'on_actions_list';

//Regions
export const ON_REGIONS_LIST = 'on_regions_list';

//Branches
export const ON_BRANCHES_LIST = 'on_branches_list';

//Handovers
export const ON_HANDOVERS_LIST = 'on_handovers_list';
export const ON_HANDOVERS_ADD = 'on_handovers_add';
export const ON_HANDOVERS_UPDATE = 'on_handovers_update';

//MFA
export const MFA_RESPONSE_DATA = 'mfa_response_data';
export const TEMPORARY_USER_TOKEN = 'temporary_user_token';

//Com Signatory 1
export const SIGNATORY1_FETCH_START = 'signatory1_fetch_start';
export const SIGNATORY1_FETCH_DONE = 'signatory1_fetch_done';
export const SIGNATORY1_FETCH_ERROR = 'signatory1_fetch_error';
export const SIGNATORY1_IMAGES = 'signatory1_images';

//Com Signatory 2
export const SIGNATORY2_FETCH_START = 'signatory2_fetch_start';
export const SIGNATORY2_FETCH_DONE = 'signatory2_fetch_done';
export const SIGNATORY2_FETCH_ERROR = 'signatory2_fetch_error';
export const SIGNATORY2_IMAGES = 'signatory2_images';

//Com Representative 1
export const REPRESENTATIVE1_FETCH_START = 'representative1_fetch_start';
export const REPRESENTATIVE1_FETCH_DONE = 'representative1_fetch_done';
export const REPRESENTATIVE1_FETCH_ERROR = 'representative1_fetch_error';
export const REPRESENTATIVE1_IMAGES = 'representative1_images';
//Com Representative 2
export const REPRESENTATIVE2_FETCH_START = 'representative2_fetch_start';
export const REPRESENTATIVE2_FETCH_DONE = 'representative2_fetch_done';
export const REPRESENTATIVE2_FETCH_ERROR = 'representative2_fetch_error';
export const REPRESENTATIVE2_IMAGES = 'representative2_images';

//Custodian 1
export const CUSTODIAN1_FETCH_START = 'custodian1_fetch_start';
export const CUSTODIAN1_FETCH_DONE = 'custodian1_fetch_done';
export const CUSTODIAN1_FETCH_ERROR = 'custodian1_fetch_error';
export const CUSTODIAN1_IMAGES = 'custodian1_images';
//Custodian 2
export const CUSTODIAN2_FETCH_START = 'custodian2_fetch_start';
export const CUSTODIAN2_FETCH_DONE = 'custodian2_fetch_done';
export const CUSTODIAN2_FETCH_ERROR = 'custodian2_fetch_error';
export const CUSTODIAN2_IMAGES = 'custodian2_images';

//Verifier
export const VERIFIER_FETCH_START = 'verifier_fetch_start';
export const VERIFIER_FETCH_DONE = 'verifier_fetch_done';
export const VERIFIER_FETCH_ERROR = 'verifier_fetch_error';
export const VERIFIER_IMAGES = 'verifier_images';
//Authorizer 2
export const AUTHORIZER_FETCH_START = 'authorizer_fetch_start';
export const AUTHORIZER_FETCH_DONE = 'authorizer_fetch_done';
export const AUTHORIZER_FETCH_ERROR = 'authorizer_fetch_error';
export const AUTHORIZER_IMAGES = 'authorizer_images';
export const RESET_INTENT_USER_IMAGES = 'reset_intent_user_images';

//Intent file
export const INTENT_FILE_FETCH_START = 'intent_file_fetch_start';
export const INTENT_FILE_FETCH_DONE = 'intent_file_fetch_done';
export const INTENT_FILE_FETCH_ERROR = 'intent_file_fetch_error';
export const INTENT_FILE = 'intent_file';
export const RESET_INTENT_FILE = 'intent_file_reset';

export const ON_FINGER_VERIFICATION= 'on_finger_verification';
